import styles from "./index.module.css";
import GPU1 from "../../icons/GPU1.svg";
import GPU2 from "../../icons/GPU2.svg";
import GPU3 from "../../icons/GPU3.svg";
import GPUN from "../../icons/GPUN.png";
import Personal1 from "../../icons/Personal balance1.svg";
import Personal2 from "../../icons/Personal balance2.svg";
import Personal3 from "../../icons/Personal balance3.svg";
import Personal4 from "../../icons/Personal balance4.svg";
import Line from "../Line/Line";

const SquareProof = () => {
  return (
    <div className={styles.square}>
      <div className={styles.squareC}>
        <div className={styles.gpuItem}>
          <div className={styles.gpu}>
            <div className={styles.dot} />
            <img src={GPU1} alt="GPU1" />
          </div>
          <Line />
          <div className={styles.personal}>
            <img src={Personal1} alt="Personal1" />
          </div>
        </div>
        <div className={styles.gpuItem}>
          <div className={styles.gpu}>
            <div className={styles.dot1} />
            <img src={GPU2} alt="GPU2" />
          </div>
          <Line />
          <div className={styles.personal}>
            <img src={Personal2} alt="Personal2" />
          </div>
        </div>
        <div className={styles.gpuItem}>
          <div className={styles.gpu}>
            <div className={styles.dot2} />
            <img src={GPU3} alt="GPU3" />
          </div>
          <Line />
          <div className={styles.personal}>
            <img src={Personal3} alt="Personal3" />
          </div>
        </div>
        <div className={styles.gpuItem}>
          <div className={styles.gpu}>
            <img src={GPUN} alt="GPUN" />
          </div>

          <div className={styles.dottedLine}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="110"
              height="4"
              viewBox="0 0 110 4"
              fill="none"
            >
              <path
                d="M0 2.00195H110"
                stroke="#10C237"
                stroke-width="3"
                stroke-dasharray="6 6"
              />
            </svg>
          </div>

          <div className={styles.personal}>
            <img src={Personal4} alt="Personal4" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SquareProof;
